import { SimpleSocialLanding } from "@/components/SimpleSocialLanding";
import { BRAND_PERSON_NAME } from "@/lib/brandConfig";

const Instagram = () => (
  <SimpleSocialLanding
    seoPageKey="instagram"
    i18nPrefix="simplePages.instagram"
    imageAlt={`${BRAND_PERSON_NAME} - Instagram content creator profile photo`}
  />
);

export default Instagram;
